// import all images and export them as an object
import giftCardimage from "./giftCardImage.png";

const images = {
  giftCardimage,
};
export default images;
